const fundraising = {
  validation_errors: 'Erreur de validation',
  ticketing: {
    title_required: 'Le titre est requis',
    event_date_required: "La date de l'événement est requise",
    location_name_required: 'Le nom du lieu est requis',
    location_address_required: "L'adresse du lieu est requise",
    contact_name_required: 'Le nom du contact est requis',
    contact_phone_required: 'Le téléphone du contact est requis',
    contact_email_required: "L'email du contact est requis",
    contact_email_invalid: "L'email du contact doit être valide",
    ticket_send_mode_required: "Le mode d'envoi des billets est requis",
    ticket_send_mode_invalid: "Le mode d'envoi des billets est invalide",
  },
};
export default fundraising;
